import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';


class Tabs extends Component {
    static propTypes = {
      children: PropTypes.instanceOf(Array).isRequired,
    }
  
    constructor(props) {
      super(props);

      this.state = {
        activeTab: props.activeTab? props.activeTab : this.props.children.find(p=>p).props.label,
        isDisabled: props.isDisabled
      };
    }

    selectTab =(tab) => {
      if (this.props.OnTabChange) this.props.OnTabChange(tab);
      this.setState({ activeTab: tab });
    }
    
    render() {
        const {
          selectTab,
          props: {
            children,
          },
          state: {
            activeTab,
          }
        } = this;
    
        return (
          <div className="tabs">
            <ol className="tab-list">
              {children.filter(p=>p).map((child) => {
                const { label } = child.props;
    
                return (
                  <Tab
                    activeTab={activeTab}
                    key={label}
                    label={label}
                    onClick={!this.state.isDisabled && selectTab}
                    isDisabled={this.state.isDisabled}
                  />
                );
              })}
            </ol>
            <div className="tab-content">
              {children.filter(p=>p).map((child) => {
                if (child.props.label !== activeTab) return undefined;
                return child.props.children;
              })}
            </div>
          </div>
        );
      }
    }
    
    export default Tabs;